/**
 * 🎯 Name Collection Wrapper
 * Handles route state and passes data to NameCollection component
 */

import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import NameCollection from './NameCollection';

interface LocationState {
  email: string;
  isWaitlistUser: boolean;
  waitlistData?: {
    first_name?: string;
    last_name?: string;
  };
}

export const NameCollectionWrapper: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;

  // If no state provided, redirect to login
  if (!state || !state.email) {
    console.warn('⚠️ NameCollection accessed without required state, redirecting to login');
    return <Navigate to="/" replace />;
  }

  return (
    <NameCollection
      email={state.email}
      isWaitlistUser={state.isWaitlistUser}
      waitlistData={state.waitlistData}
    />
  );
};

export default NameCollectionWrapper;
